/**
 * @file customer-email.ts
 * @description Правило «у клиента обязан быть e-mail» (customers.md F15,
 * решение пользователя 2026-09-21).
 *
 * Один источник для трёх мест: диалог клиента, инлайн-поле в форме заказа и
 * будущие импорты. Раньше каждая форма проверяла адрес по-своему («email или
 * телефон»), и клиент без почты доходил до согласования доставки, где письмо
 * отправлять уже некуда.
 *
 * Проверка намеренно мягкая (есть «@», есть точка в домене, нет пробелов):
 * строгая RFC-регулярка отвергает живые адреса, а настоящую доставляемость
 * всё равно показывает только отправка письма.
 */

/** Зачем магазину почта клиента — один текст на все формы. */
export const CUSTOMER_EMAIL_HINT =
  "E-mail нужен для согласований и писем по заказу";

/** Текст, когда адреса нет вовсе. */
export const CUSTOMER_EMAIL_REQUIRED_TEXT =
  "Укажите e-mail: без него нельзя отправить согласование и письма по заказу.";

/** Текст, когда адрес введён с ошибкой. */
export const CUSTOMER_EMAIL_INVALID_TEXT =
  "Проверьте e-mail: нужен адрес вида ivanov@mail.ru.";

/** Формат адреса: что-то@что-то.домен без пробелов. */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/u;

/** Похоже ли на рабочий адрес. */
export function isValidEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}

/**
 * Проблема с e-mail клиента человеческим текстом; `null` — всё в порядке.
 * Пустое значение — ошибка: адрес обязателен (F15).
 */
export function validateCustomerEmail(value: string): string | null {
  if (!value.trim()) return CUSTOMER_EMAIL_REQUIRED_TEXT;
  return isValidEmail(value) ? null : CUSTOMER_EMAIL_INVALID_TEXT;
}
